var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"title":_vm.$t('program.upload_video_management' /* 视频上传管理 */),"width":"85%","placement":"right","closable":true,"visible":_vm.visible},on:{"close":_vm.handleDrawerClose}},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.url,"scrolling":"no","id":"receiver","width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }